<template>
    <b-modal
        :title="$t('import_csv')"
        :visible="value"
        @close="$emit('input', false)"
        @shown="initializeDialog"
        id="product-import-dialog"
        size="lg"
        no-close-on-backdrop
        :ok-title="okTitle"
        @ok="save"
        :ok-disabled="!saveButtonEnabled"
        @cancel="$emit('input', false)"
        :cancel-disabled="tally !== null"
    >
        <div class="row" v-if="!tally">
            <div class="col-md-6">
                <h5>How should the CSV file be formatted?</h5>
                <ul>
                    <li>
                        Required columns: <code>collection</code>,
                        <code>product</code>, <code>variant</code>,
                        <code>reference</code>
                    </li>
                    <li>
                        Attribute columns should start with
                        <code>attribute_</code> (for example
                        <strong>attribute_material</strong>)
                    </li>
                </ul>
                <p>
                    Please note that references can not occur twice for a given
                    client, so if the CSV contains two products with the same
                    reference, the last reference in the CSV will overwrite the
                    previous one, there won't be two product variants
                </p>
            </div>
            <div class="col offset-md-1">
                <h5>Upload a CSV</h5>
                <b-form :disabled="saving" enctype="multipart/form-data">
                    <b-form-group>
                        <b-select
                            :label="$t('select_client')"
                            id="clientSelect"
                            v-model="client"
                            name="client"
                            class="form-control"
                            :required="true"
                        >
                            <b-select-option :value="null">{{
                                $t("select_client")
                            }}</b-select-option>
                            <b-select-option
                                v-for="c in clients"
                                :value="c.id"
                                :key="c.id"
                                >{{ c.name }}</b-select-option
                            >
                        </b-select>
                    </b-form-group>
                    <b-form-group class="form-group">
                        <b-form-file
                            v-model="file"
                            :state="Boolean(file)"
                            accept="text/csv, .csv"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </b-form-group>
                </b-form>
            </div>
        </div>
        <div v-else>
            <product-import-tally :tally="tally"></product-import-tally>
        </div>
    </b-modal>
</template>

<script>
import axios from "axios";
import ProductImportTally from "./ProductImportTally";
export default {
  name: "ProductImporter",
  components: { ProductImportTally },
  props: {
    value: Boolean
  },
  data() {
    return {
      clients: [],
      client: null,
      saving: false,
      file: null,
      tally: null
    };
  },
  computed: {
    saveButtonEnabled() {
      return this.tally || (!this.saving && this.client && this.file);
    },
    okTitle() {
      if (this.tally) {
        return this.$t("close");
      } else if (this.saving) {
        return this.$t("importing");
      } else {
        return this.$t("import_csv");
      }
    }
  },
  methods: {
    initializeDialog() {
      this.file = null;
      this.client = null;
      this.tally = null;
      this.getClients();
    },
    getClients() {
      return axios.get("/api/clients").then(r => {
        this.clients = r.data.data;
      });
    },
    save(bvModalEvent) {
      // If a tally is displayed, the button should close the dialog
      if (this.tally) {
        this.$emit("input", false);
      }

      bvModalEvent.preventDefault();
      this.saving = true;

      let fd = new FormData();
      fd.append("products", this.file);
      fd.append("client", this.client);

      axios
        .post("/api/smart-vault/import-products", fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(r => {
          this.file = null;
          this.client = null;
          this.tally = r.data.tally;
          this.$emit("saved", true);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style scoped>
</style>
